import { type FC } from 'react'
import { DateRangeInput } from 'recruiter/components/DateRangeInput'
import { FilterWrapper } from 'recruiter/components/FilterWrapper'

interface MinimalCreationDateFilterProps {
    createdAtGte: string | undefined
    createdAtLte: string | undefined
    onChange: (patch: { createdAtGte?: string; createdAtLte?: string }) => void
}

export const MinimalCreationDateFilter: FC<MinimalCreationDateFilterProps> = ({
    createdAtGte,
    createdAtLte,
    onChange,
}) => {
    const fromDate = createdAtGte ? new Date(createdAtGte) : null
    const toDate = createdAtLte ? new Date(createdAtLte) : null

    const handleChange = (key: 'gte' | 'lte', date: Date | null) => {
        const isValidDate = date && !isNaN(date.getTime())
        const isoString = isValidDate ? date.toISOString() : undefined
        if (key === 'gte') {
            onChange({ createdAtGte: isoString })
        } else {
            onChange({ createdAtLte: isoString })
        }
    }

    return (
        <FilterWrapper label="Creation Date">
            <DateRangeInput
                from={fromDate}
                to={toDate}
                onFromChange={(d) => handleChange('gte', d)}
                onToChange={(d) => handleChange('lte', d)}
            />
        </FilterWrapper>
    )
}
